import { type FC } from 'react';
import styled from 'styled-components';

import { InternalLink } from '@/components/InternalLink';
import { useTexts } from '@/hooks/useTexts';

import { ShowOnDesktop } from '../../Responsive/ShowOnDesktop';
import { ShowOnMobile } from '../../Responsive/ShowOnMobile';
import { StorebrandLogoChain } from './StorebrandLogoChain';
import { StorebrandLogoFull } from './StorebrandLogoFull';

interface Props {
  to: string;
}

export const StorebrandLogoWithMediaQuery: FC<Props> = ({ to }) => {
  const texts = useTexts();

  return (
    <>
      <ShowOnDesktop>
        <StyledLink to={to} aria-label={texts.topmenu.logo.ariaLabel}>
          <StorebrandLogoFull />
        </StyledLink>
      </ShowOnDesktop>

      <ShowOnMobile>
        <StyledLink to={to} aria-label={texts.topmenu.logo.ariaLabel}>
          <StorebrandLogoChain />
        </StyledLink>
      </ShowOnMobile>
    </>
  );
};

const StyledLink = styled(InternalLink)`
  display: flex;
`;
